import React from 'react';

export default ({ error }) => (
    error &&
    <span className="nhsuk-error-message">
        <span className="nhsuk-u-visually-hidden">Error:</span> {error}
    </span>
);
